var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6562 1.5625H16.7188V0H15.1562V1.5625H4.84375V0H3.28125V1.5625H2.34375C1.05141 1.5625 0 2.61391 0 3.90625V17.6562C0 18.9486 1.05141 20 2.34375 20H17.6562C18.9486 20 20 18.9486 20 17.6562V3.90625C20 2.61391 18.9486 1.5625 17.6562 1.5625ZM18.4375 17.6562C18.4375 18.087 18.087 18.4375 17.6562 18.4375H2.34375C1.91297 18.4375 1.5625 18.087 1.5625 17.6562V7.34375H18.4375V17.6562ZM18.4375 5.78125H1.5625V3.90625C1.5625 3.47547 1.91297 3.125 2.34375 3.125H3.28125V4.6875H4.84375V3.125H15.1562V4.6875H16.7188V3.125H17.6562C18.087 3.125 18.4375 3.47547 18.4375 3.90625V5.78125Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53125 8.98438H2.96875V10.5469H4.53125V8.98438Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65625 8.98438H6.09375V10.5469H7.65625V8.98438Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 8.98438H9.21875V10.5469H10.7812V8.98438Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9062 8.98438H12.3438V10.5469H13.9062V8.98438Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0312 8.98438H15.4688V10.5469H17.0312V8.98438Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53125 12.1094H2.96875V13.6719H4.53125V12.1094Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65625 12.1094H6.09375V13.6719H7.65625V12.1094Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 12.1094H9.21875V13.6719H10.7812V12.1094Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9062 12.1094H12.3438V13.6719H13.9062V12.1094Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53125 15.2344H2.96875V16.7969H4.53125V15.2344Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65625 15.2344H6.09375V16.7969H7.65625V15.2344Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 15.2344H9.21875V16.7969H10.7812V15.2344Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9062 15.2344H12.3438V16.7969H13.9062V15.2344Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0312 12.1094H15.4688V13.6719H17.0312V12.1094Z",
    fill: "#DE513C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4f3ab1e0ce2e7aac9ddcb842d7e90bd5.svg";
export { ForwardRef as ReactComponent };